import {createDesignItem,hasCompleteSizing} from './design-model.js';

// Checkout contact details live only in App memory, never in the persisted design/cart.
export function emptyCheckoutDraft(){return {name:'',phone:'',country:'CN',province:'',city:'',address:'',postalCode:'',note:''};}
export function accountIdentity(user){return user ? String(user.id ?? user.email) : null;}
export function shouldClearCheckout(previous,next,{explicitLogout=false,fromLogin=false}={}){
  if(explicitLogout)return true;
  if(previous!=null && previous!==next)return true;
  return next!=null && previous!==next && !fromLogin;
}

// Replace one mutable bag line. Submitted order snapshots are deliberately not inputs.
export function replaceCartDesign(cart,itemId,design){
  const item=cart.find(entry=>entry.id===itemId);
  if(!item || item.kind!=='custom')throw new Error('这份设计已不在购物袋中，请返回购物袋重新选择。');
  if(!hasCompleteSizing(design))throw new Error('请补齐左右手十指尺寸');
  const replacement={...createDesignItem(design),id:item.id,quantity:item.quantity};
  return cart.map(entry=>entry.id===itemId?replacement:entry);
}
